import {
  SPACE_SELECTOR_ITEM_TYPE,
  SPACE_SELECTOR_SORT,
} from '../../constants/analytics';
import { analyticsTrackEvent } from '../../utils/analytics';
import { openTimestamp, openCorrelationId } from '../selectors';
import getNow from '../getNow';

const sortSpaceSelector =
  (previousSort, sort, showArchived, category) => (_dispatch, getState) => {
    const state = getState();

    analyticsTrackEvent(SPACE_SELECTOR_SORT, {
      itemType: SPACE_SELECTOR_ITEM_TYPE,
      selectorOpenFor: Math.round(getNow() - openTimestamp(state)),
      correlationId: openCorrelationId(state),
      previousSort,
      sort,
      showArchived,
      categoriesEnabled: true,
      category,
    });
  };

export default sortSpaceSelector;
